import api from "./api";

export class AccountService {
    SendTransporterEmail(data: {id: string; emailDriver: string}) {
        return api.post("/sendTransporterEmail", {data});
    }

    SendCertificateToDriver(emailDriver: string) {
        return api.get("/validateExam", { params: { emailDriver } });
    }
}
